import { InputAdornment, styled, TextareaAutosize, TextField } from "@mui/material";
import { StyledSpeechToText } from "../../styled/speechToText";

const DarkerDisabledTextField = styled(TextField)({
  "& .MuiInputBase-root.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.35)",
  },
  "& .MuiFormLabel-root.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.35)",
  },
});

const DarkerDisabledTextFieldWrapper = (props) => {
  const { minRows = 3 } = props;
  return (
    <DarkerDisabledTextField
      {...props}

      {...(props.multiline ? {

        InputProps: {
          inputComponent: TextareaAutosize,
          inputProps: {
            minRows: minRows,
            maxRows: minRows * 2,
            style: {
              resize: "vertical",
              overflowY: 'auto',
            },
          },
        },
        endAdornment: (
          <InputAdornment position="end" sx={{ ml: 4 }}>
            <StyledSpeechToText.Container>
              <StyledSpeechToText.Mic disabled={props.disabled} />
            </StyledSpeechToText.Container>
          </InputAdornment>
        ),
      } : {})}
      disabled={true}
    />
  );
};

export default DarkerDisabledTextFieldWrapper;
